import { useState } from "react";
import { faqs } from "@/mocks/homeNews";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-24">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <span className="inline-flex items-center rounded-full bg-secondary-200/70 px-3 py-1 text-xs font-semibold text-secondary-800">
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">吃瓜前，你可能想先知道这些</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-500">关于更新节奏、栏目区别与内容使用的小说明。</p>
        </div>

        <div className="mt-8 divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-secondary-100/50 md:px-6"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={
                        "flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold " +
                        (open ? "bg-primary-500 text-background-50 dark:text-foreground-950" : "bg-secondary-100 text-foreground-600")
                      }
                    >
                      Q{i + 1}
                    </span>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{f.q}</h3>
                  </span>
                  <i className={"ri-arrow-down-s-line shrink-0 text-lg text-foreground-400 transition-transform " + (open ? "rotate-180 text-primary-600" : "")} />
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-[52px] md:px-6 md:pl-[58px]">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}